module.exports = __webpack_public_path__ + "static/img/help_06intro_21.a6a4478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_06intro_21.png
// module id = 727
// module chunks = 140